import React, { lazy, Suspense, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import { useEffect } from "react";
import "./App.css";
import "./Style.css";
import "./Payments.css";
import "./Home.css";
import { IS_CORPORATE } from "./api/Constants";
import CorporateStyles from "./components/CorporateStyles";
import Promotions from "./components/Promotions";
import Navbar from "./components/Navbar";

const oldLogin = lazy(() => import("./components/auth/oldLogin"));
const Register = lazy(() => import("./components/auth/Register"));
const ResetPassword = lazy(() => import("./components/auth/ResetPassword"));
const CompetitionDetail = lazy(() =>
  import("./components/frontend/CompetitionDetail")
);
const OtpVerify = lazy(() => import("./components/auth/OtpVerify"));
const Dashboard = lazy(() => import("./components/Dashboard/Dashboard"));
const CreateCompetition = lazy(() =>
  import("./components/Dashboard/CreateCompetition")
);
const EditProfile = lazy(() => import("./components/Dashboard/EditProfile"));
const MyCompetitions = lazy(() =>
  import("./components/Dashboard/MyCompetitions")
);
const CompetitionDashboard = lazy(() =>
  import("./components/Dashboard/competetion/CompetitionDashboard")
);
const ForgotPassword = lazy(() => import("./components/auth/ForgotPassword"));
const OldHome = lazy(() => import("./components/frontend/OldHome"));
const WorkoutDetail = lazy(() =>
  import("./components/Dashboard/competetion/WorkoutDetail")
);
const AllCompetitions = lazy(() =>
  import("./components/frontend/AllCompetitions")
);
const HealthFormulasReference = lazy(() =>  
  import("./components/frontend/HealthFormulasReference")
);

const CompetitionWorkouts = lazy(() =>
  import("./components/frontend/CompetitionWorkouts")
);
// Original Compete component - now using CompeteV2 as default
// Uncomment below if you need to revert to the original Compete flow
// const Compete = lazy(() => import("./components/frontend/compete/Compete"));
const CompeteV2 = lazy(() => import("./components/frontend/compete/CompeteV2"));
const PaymentCart = lazy(() => import("./components/frontend/compete/PaymentCart"));
const Volunteer = lazy(() =>
  import("./components/frontend/volunteer/Volunteer")
);
const Teams = lazy(() => import("./components/frontend/compete/Teams"));
const Team = lazy(() => import("./components/frontend/Team"));
const CompetitionCreated = lazy(() =>
  import("./components/Dashboard/competetion/CompetitionCreated")
);
const Leaderboard = lazy(() => import("./components/frontend/Leaderboard"));
const Refresh = lazy(() => import("./components/frontend/payments/Refresh"));
const Return = lazy(() => import("./components/frontend/payments/Return"));
const StripeProfile = lazy(() =>
  import("./components/frontend/payments/StripeHome")
);
const PaymentIntent = lazy(() =>
  import("./components/frontend/compete/PaymentIntent")
);
const Contact = lazy(() => import("./components/Contact"));
const Messages = lazy(() => import("./components/Dashboard/Messages"));
const HelpCenter = lazy(() => import("./components/HelpCenter"));
const Home = lazy(() => import("./components/frontend/Home"));
const AllEvents = lazy(() => import("./components/frontend/AllEvents"));
const EventDetail = lazy(() => import("./components/frontend/EventDetail"));
const Tenants = lazy(() => import("./components/frontend/Tenants"));

const Judging = lazy(() => import("./components/Dashboard/Judging"));
const Communities = lazy(() => import("./components/frontend/Communities"));
const CommunityDetail = lazy(() =>
  import("./components/frontend/CommunityDetail")
);
const MyCommunities = lazy(() =>
  import("./components/Dashboard/MyCommunities")
);
const MyEvents = lazy(() => import("./components/Dashboard/MyEvents"));
const EventPaymentIntent = lazy(() =>
  import("./components/frontend/compete/EventPaymentIntent")
);
const FeaturedContent = lazy(() =>
  import("./components/Dashboard/FeaturedContent")
);

const Revenues = lazy(() => import("./components/Dashboard/Revenues"));

const Profile = lazy(() => import("./components/Dashboard/Profile"));

const Users = lazy(() => import("./components/Dashboard/Users"));
const AddUser = lazy(() => import("./components/Dashboard/AddUser"));
const EditUser = lazy(() => import("./components/Dashboard/EditUser"));
const UserMemberships = lazy(() => import("./components/Dashboard/UserMemberships"));
const ClientMemberships = lazy(() => import("./components/Dashboard/ClientMemberships"));
const Groups = lazy(() => import("./components/Dashboard/Groups"));
const AddGroup = lazy(() => import("./components/Dashboard/AddGroup"));

const PublicFeed = lazy(() => import("./components/Dashboard/Posts"));
const AddPost = lazy(() => import("./components/Dashboard/AddPost"));

const Activities = lazy(() => import("./components/Dashboard/Activities"));
const AddActivity = lazy(() => import("./components/Dashboard/AddActivity"));
const ActivitiesTypes = lazy(() => import("./components/Dashboard/ActivitiesTypes"));
const AddActivityType = lazy(() => import("./components/Dashboard/AddActivityType"));
const CorporateCommunities = lazy(() =>
  import("./components/Dashboard/CorporateCommunities")
);
const AddCommunity = lazy(() => import("./components/Dashboard/AddCommunity"));
const Branding = lazy(() => import("./components/Dashboard/Branding"));
const ManageTenants = lazy(() => import("./components/Dashboard/ManageTenants"));
const AiUsage = lazy(() => import("./components/Dashboard/AiUsage"));

const GetTrial = lazy(() => import("./components/frontend/GetTrial"));
const CorporateChallenges = lazy(() =>
  import("./components/Dashboard/CorporateChallenges")
);
const AddChallenge = lazy(() => import("./components/Dashboard/AddChallenge"));
const ChallengeRequests = lazy(() =>
  import("./components/Dashboard/ChallengeRequests")
);
const TrainerRequests = lazy(() =>
  import("./components/Dashboard/TrainerRequests")
);
const TraineeProgramRequests = lazy(() =>
  import("./components/Dashboard/TraineeProgramRequests")
);
const Login = lazy(() => import("./components/auth/Login"));
const LoginOtpVerify = lazy(() => import("./components/auth/LoginOtpVerify"));
const UserProfile = lazy(() => import("./components/Dashboard/UserProfile"));
const TrackDiet = lazy(() => import("./components/Dashboard/TrackDiet"));

const FitnessTrainer = lazy(() =>
  import("./components/Dashboard/FitnessTrainer")
);

const Nutritionist = lazy(() => import("./components/Dashboard/Nutritionist"));
const NutritionistWeaviate = lazy(() => import("./components/Dashboard/NutritionistWeaviate"));
const NutritionistPinecone = lazy(() => import("./components/Dashboard/NutritionistPinecone"));
const NewCreateEvent = lazy(() => import("./components/Dashboard/Event"));
const UserPublicProfile = lazy(() =>
  import("./components/frontend/UserPublicProfile")
);
const Subscriptions = lazy(() => import("./components/frontend/Subscriptions"));
const TrainerClients = lazy(() =>
  import("./components/Dashboard/TrainerClients")
);
const AllSubscriptions = lazy(() =>
  import("./components/Dashboard/AllSubscriptions")
);
const AllSubscribers = lazy(() =>
  import("./components/Dashboard/AllSubscribers")
);

// page pages
const MobileTrackDiet = lazy(() =>
  import("./components/frontend/MobilePages/MobileTrackDiet")
);
const MobileFitnessTrainer = lazy(() =>
  import("./components/frontend/MobilePages/MobileFitnessTrainer")
);
const MobileEvent = lazy(() =>
  import("./components/frontend/MobilePages/MobileEvent")
);
const MobileEventDetails = lazy(() =>
  import("./components/frontend/MobilePages/MobileEventDetails")
);
const MobileMyTickets = lazy(() =>
  import("./components/frontend/MobilePages/MobileMyTickets")
);
const MobileReceivedOrders = lazy(() =>
  import("./components/frontend/MobilePages/MobileReceivedOrders")
);

/// partners  & products
const PartnersPublic = lazy(() => import("./components/frontend/PartnersPublic")); //public page
const PartnersDashboard = lazy(() => import("./components/Dashboard/PartnersDashboard"));
const AddPartner = lazy(() => import("./components/PageComponents/Partners/AddPartner"));
const PartnerDetails = lazy(() => import("./components/PageComponents/Partners/ViewDetails"));
const PartnerProducts = lazy(() => import("./components/PageComponents/Partners/Products/PartnerProducts"));
const AddProduct = lazy(() => import("./components/PageComponents/Partners/Products/AddProduct"));


//Gym inventory management
const GymInventoryManagement = lazy(() => import("./components/Dashboard/gym_management/GymInventoryManagement"));
const ExpenseManagement = lazy(() => import("./components/Dashboard/expense_management/ExpenseManagement"));
const GymRevenueManagement = lazy(() => import("./components/PageComponents/GymMembership/GymRevenueManagement"));

const CHECK_INTERVAL = 300000; // Check every 5 minutes
const basename = process.env.REACT_APP_BASENAME || "/";

const getPromoStatus = () => {
  const lastClosed = localStorage.getItem("promo_closed_at");

  if (!lastClosed) return true;

  const lastClosedTime = new Date(parseInt(lastClosed, 30));
  const currentTime = new Date();

  // Check if 24 hours have passed
  const timeDifference = currentTime - lastClosedTime;
  const twentyFourHours = 24 * 60 * 60 * 1000;

  return timeDifference >= twentyFourHours; // Show promo again if 24 hours have passed
};

//inject to avoid auto scaling views
function App() {
  useEffect(() => {
    let meta = document.querySelector("meta[name=viewport]");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "viewport";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
    meta.content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
  }, []);

  const [showPromotions, setShowPromotions] = useState(getPromoStatus);

  const metaToken = localStorage.getItem("metatoken");

  const checkAccess = !(IS_CORPORATE && !metaToken);

  const [currentVersion, setCurrentVersion] = useState(null);

  //check version to reload when new build is deployed
  useEffect(() => {
    const fetchVersion = async () => {
      try {
        let versionFile = "/version.json"; // Default to root path
        if (basename !== "/") {
          versionFile = `${basename}/version.json`; // Adjust for subdirectory
        }
        const response = await fetch(versionFile, { cache: "no-store" });
        const data = await response.json();

        // Get the stored version from localStorage (or sessionStorage)
        const storedVersion = localStorage.getItem("appVersion");

        // If the stored version exists and is different, reload the page
        if (storedVersion && storedVersion !== data.version) {
          console.log("New version detected. Reloading...");
          window.location.reload();
        }

        // Store the latest version
        localStorage.setItem("appVersion", data.version);
        setCurrentVersion(data.version);
      } catch (error) {
        console.error("Failed to fetch version:", error);
      }
    };

    fetchVersion(); // Run on first load
    const interval = setInterval(fetchVersion, CHECK_INTERVAL); // Run every 60 sec
    return () => clearInterval(interval);
  }, []);

  const handleShowPromotions = () => {
    setShowPromotions(false);
    localStorage.setItem("promo_closed_at", Date.now().toString());
  };

  return (
    <div className="App">
      <div>
        <Suspense
          fallback={
            <div>
              <div className="loader-parent">
                <div className="_loader"></div>
              </div>
            </div>
          }
        >
          <Router basename={basename}>
            {checkAccess ? (
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/all-competetions" element={<Home />} />
                <Route exact path="/events" element={<AllEvents />} />
                <Route exact path="/tenants" element={<Tenants />} />
                <Route exact path="/manage-tenants" element={<ManageTenants />} />
                <Route exact path="/manage-tenats" element={<ManageTenants />} />
                <Route exact path="/ai-usage" element={<AiUsage />} />
                <Route exact path="/event" element={<NewCreateEvent />} />
                <Route
                  exact
                  path="/event-detail/:id"
                  element={<EventDetail />}
                />
                <Route exact path="/communities" element={<Communities />} />
                <Route
                  exact
                  path="/community-detail/:id"
                  element={<CommunityDetail />}
                />
                <Route
                  exact
                  path="/my-communities"
                  element={<MyCommunities />}
                />
                <Route exact path="/my-events" element={<MyEvents />} />
                <Route
                  exact
                  path="/event-payment-intent/:id"
                  element={<EventPaymentIntent />}
                />
                <Route exact path="/branding" element={<Branding />} />
                <Route exact path="/all-users" element={<Users />} />
                <Route exact path="/add-user" element={<AddUser />} />
                <Route exact path="/edit-user/:id" element={<EditUser />} />
                <Route exact path="/memberships" element={<UserMemberships />} />
                <Route exact path="/client-memberships" element={<ClientMemberships />} />
                <Route
                  exact
                  path="/clients"
                  element={<TrainerClients />}
                />
                <Route exact path="/all-groups" element={<Groups />} />
                <Route exact path="/add-group" element={<AddGroup />} />
                <Route exact path="/public-feed" element={<PublicFeed />} />
                <Route exact path="/all-activities" element={<Activities />} />
                <Route exact path="/add-activity" element={<AddActivity />} />
                <Route exact path="/all-activities-types" element={<ActivitiesTypes />} />
                <Route exact path="/add-activity-type" element={<AddActivityType />} />
                <Route
                  exact
                  path="/all-communities"
                  element={<CorporateCommunities />}
                />
                <Route exact path="/add-community" element={<AddCommunity />} />
                <Route
                  exact
                  path="/all-challenges"
                  element={<CorporateChallenges />}
                />
                <Route exact path="/add-challenge" element={<AddChallenge />} />
                <Route
                  exact
                  path="/challenge-requests"
                  element={<ChallengeRequests />}
                />
                <Route
                  exact
                  path="/requests-trainer"
                  element={<TrainerRequests />}
                />
                <Route
                  exact
                  path="/program-requests"
                  element={<TraineeProgramRequests />}
                />
                <Route
                  exact
                  path="/all-subscriptions"
                  element={<AllSubscriptions />}
                />
                <Route
                  exact
                  path="/all-subscribers"
                  element={<AllSubscribers />}
                />
                <Route exact path="/profile" element={<Profile />} />
                <Route exact path="/track-diet" element={<TrackDiet />} />
                <Route exact path="/nutritionist" element={<Nutritionist />} />
                <Route exact path="/nutritionist_weaviate" element={<NutritionistWeaviate />} />
                <Route exact path="/nutritionist_pinecone" element={<NutritionistPinecone />} />
                <Route
                  exact
                  path="/fitness-trainer"
                  element={<FitnessTrainer />}
                />
                <Route exact path="/old-login" element={<oldLogin />} />
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/old-home" element={<OldHome />} />
                <Route exact path="/register" element={<Register />} />
                <Route exact path="/user/:id" element={<UserProfile />} />
                <Route
                  exact
                  path="/user-profile/:id"
                  element={<UserPublicProfile />}
                />
                <Route
                  exact
                  path="/reset-password"
                  element={<ResetPassword />}
                />
                <Route
                  exact
                  path="/login-otp-verify"
                  element={<LoginOtpVerify />}
                />
                <Route exact path="/verify-otp" element={<OtpVerify />} />
                <Route exact path="/contact" element={<Contact />} />
                <Route exact path="/help-center" element={<HelpCenter />} />
                {!IS_CORPORATE && (
                  <Route exact path="/get-trial" element={<GetTrial />} />
                )}
                <Route
                  exact
                  path="/forgot-password"
                  element={<ForgotPassword />}
                />
                <Route exact path="/dashboard" element={<Dashboard />} />
                <Route
                  exacts
                  path="/my-competitions"
                  element={<MyCompetitions />}
                />
                <Route exact path="/revenues" element={<Revenues />} />
                <Route exact path="/judging" element={<Judging />} />
                <Route exact path="/edit-profile" element={<EditProfile />} />
                <Route
                  exact
                  path="/featured-content"
                  element={<FeaturedContent />}
                />
                <Route exact path="/messages" element={<Messages />} />
                <Route
                  exact
                  path="/create-competition"
                  element={<CreateCompetition />}
                />
                <Route
                  exact
                  path="/created/:id"
                  element={<CompetitionCreated />}
                />
                <Route
                  exact
                  path="/competition-dashboard/:id"
                  element={<CompetitionDashboard />}
                />
                <Route
                  exact
                  path="/old-all-competetions"
                  element={<AllCompetitions />}
                />
                <Route
                  exact
                  path="/health-formulas-reference"
                  element={<HealthFormulasReference />}
                />
                <Route
                  exact
                  path="/competition-detail/:id"
                  element={<CompetitionDetail />}
                />
                <Route
                  exact
                  path="/leaderboard/:id"
                  element={<Leaderboard />}
                />
                <Route
                  exact
                  path="/competition-workouts/:id"
                  element={<CompetitionWorkouts />}
                />
                <Route
                  exact
                  path="/workout-detail/:id"
                  element={<WorkoutDetail />}
                />
                <Route
                  exact
                  path="/subscriptions"
                  element={<Subscriptions />}
                />
                {/* Compete route - Using CompeteV2 as default, original commented below */}
                {/* <Route exact path="/compete/:id" element={<Compete />} /> */}
                <Route exact path="/compete/:id" element={<CompeteV2 />} />
                <Route exact path="/volunteer/:id" element={<Volunteer />} />

                <Route exact path="/teams/:id" element={<Teams />} />

                <Route exact path="/team/:id/:teamid" element={<Team />} />
                <Route exact path="/payment-cart/:id/:athleteIds" element={<PaymentCart />} />
                <Route path="*" element={<Home />} />

                <Route exact path="/stripe-home/" element={<StripeProfile />} />
                <Route
                  exact
                  path="/payment-intent/:id/:athleteId"
                  element={<PaymentIntent />}
                />
                <Route
                  exact
                  path="/refresh/:connectedAccountId"
                  element={<Refresh />}
                />
                <Route
                  exact
                  path="/return/:connectedAccountId"
                  element={<Return />}
                />

                {/* mobile page routes */}
                <Route
                  exact
                  path="/mobile-track-diet"
                  element={<MobileTrackDiet />}
                />
                <Route
                  exact
                  path="/mobile-fitness-trainer"
                 element={<MobileFitnessTrainer />}
                />
                <Route exact path="/mobile-event" element={<MobileEvent />} />
                <Route
                  exact
                  path="/mobile-event-detail/:id"
                  element={<MobileEventDetails />}
                />
                <Route
                  exact
                  path="/received-orders"
                  element={<MobileReceivedOrders />}
                />

                <Route exact path="/my-tickets" element={<MobileMyTickets />} />

                <Route exact path="/partners" element={<PartnersPublic />} />
                <Route exact path="/partner-details" element={<PartnerDetails />} />
                <Route exact path="/partners-dashboard" element={<PartnersDashboard />} />
                <Route exact path="/add-partner" element={<AddPartner />} />
                <Route exact path="/partner-products" element={<PartnerProducts />} />
                <Route exact path="/add-product" element={<AddProduct />} />

                <Route exact path="/gym-inventory" element={<GymInventoryManagement />} />
                <Route exact path="/expense-management" element={<ExpenseManagement />} />
                <Route exact path="/revenue-management" element={<GymRevenueManagement />} />
                
              </Routes>
            ) : (
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/register" element={<Register />} />
                <Route exact path="/tenants" element={<Tenants />} />
                <Route
                  exact
                  path="/health-formulas-reference"
                  element={<HealthFormulasReference />}
                />
                <Route
                  exact
                  path="/reset-password"
                  element={<ResetPassword />}
                />
                <Route
                  exact
                  path="/forgot-password"
                  element={<ForgotPassword />}
                />
                <Route
                  exact
                  path="/login-otp-verify"
                  element={<LoginOtpVerify />}
                />
                <Route
                  exact
                  path="/mobile-track-diet"
                  element={<MobileTrackDiet />}
                />
                <Route
                  exact
                  path="/mobile-fitness-trainer"
                  element={<MobileFitnessTrainer />}
                />
                <Route exact path="/mobile-event" element={<MobileEvent />} />
                <Route
                  exact
                  path="/mobile-event-detail/:id"
                  element={<MobileEventDetails />}
                />
                <Route
                  exact
                  path="/received-orders"
                  element={<MobileReceivedOrders />}
                />
                <Route exact path="/partners" element={<PartnersPublic />} />
                <Route exact path="/partner-details" element={<PartnerDetails />} />
                <Route exact path="/my-tickets" element={<MobileMyTickets />} />
                <Route exact path="/verify-otp" element={<OtpVerify />} />
                <Route exact path="/all-competetions" element={<Home />} />
                <Route
                  exact
                  path="/competition-detail/:id"
                  element={<CompetitionDetail />}
                />
                {/* Using CompeteV2 as default for /compete/:id route - original Compete commented below */}
                {/* <Route exact path="/compete/:id" element={<Compete />} /> */}
                <Route exact path="/compete/:id" element={<CompeteV2 />} />
                {/* Alternate route for V2 if needed for testing */}
                {/* <Route exact path="/compete-v2/:id" element={<CompeteV2 />} /> */}
                <Route exact path="/payment-cart/:id/:athleteIds" element={<PaymentCart />} />
                <Route exact path="/volunteer/:id" element={<Volunteer />} />
                <Route path="*" element={<Home />} />
              </Routes>
            )}
            {checkAccess && <Footer />}
            {IS_CORPORATE && metaToken && <CorporateStyles />}

            {/* community workout programs promotions on first login, show only for public portal */}
            {/*
            {!IS_CORPORATE && showPromotions && (
              //|| (IS_CORPORATE && metaToken && showPromotions)) && (
              <Promotions handleShowPromotions={handleShowPromotions} />
            )}
            */}
          </Router>
        </Suspense>
      </div>
    </div>
  );
}

export default App;
